export default __webpack_public_path__ + "static/media/ic_place.c16e84dc.svg";